// extracted by mini-css-extract-plugin
export default {"commentContainer":"StudentTranscriptCommentSkeleton__commentContainer___vTOSf","loader":"StudentTranscriptCommentSkeleton__loader___kYpjM"};